<template>
  <div class="menu-300">

    <menu300-item v-for="item in selectedMenu" :item="item"/>

  </div>
</template>

<script>
import {MenuProps} from "../MenuProps";
import {mapGetters} from "vuex";
import Menu300Item from "./Menu300Item.vue";

export default {
  name: "Menu300",
  components: {Menu300Item},
  props: {
    ...MenuProps
  },
  computed: {
    ...mapGetters({
      storeMenus: "Menu/getAllMenus",
    }),
    selectedMenu() {
      let result = []
      this.storeMenus.forEach(item => {
        if (item.position === this.menuPosition) {
          result = item.children
        }
      })
      return result
    }
  }
}
</script>

<style scoped>

</style>